import React from 'react';
import style from './style.module.less';
import logo from './logo.svg';

function BremenLogo({ title, title2, subline, date, body }) {
    return <img className={style.logo} src={logo} />;
}

export default BremenLogo;



// WEBPACK FOOTER //
// ../components/BremenLogo/index.js